// import axios from 'axios';
import {createSlice} from '@reduxjs/toolkit';
import {AUTH_TOKEN} from 'constants/AuthConstant';
// import fetch from 'auth/FetchInterceptor'
// import AuthService from 'services/AuthService';
// import {post} from 'services/HttpService';

export const initialState = {
    loading: false,
    message: '',
    showMessage: false,
    redirect: '',
    user: {},
    token: localStorage.getItem(AUTH_TOKEN) || null,
    invalidResetPassToken: false,
    passwordReset: false,
};

// export const signIn = createAsyncThunk('auth/login', async (data, thunkAPI) => {
//     const {email, password} = data;
//
//     try {
//         // const response = await axios.post('http://localhost:8000/v1/auth/login', {email, password, source: 'w'});
//         const response = await AuthService.login({email, password, source: 'w'});
//         return thunkAPI.fulfillWithValue(response.data);
//     } catch (err) {
//         return thunkAPI.rejectWithValue(err.response?.data?.message || 'Error');
//     }
//
// });
//
// return rejectWithValue("error");
// .then((response) => {
// 	console.log('response');
// })
// .catch((error) => {
// 	console.error('error');
// 	return rejectWithValue("error");
// });
//
// await axios.get('http://localhost:8000/v1/auth/me')
// 	.then(res => fulfillWithValue(res))
// 	.catch((err) => rejectWithValue(err));
//
// try {
// const response = await axios.post('http://localhost:8000/v1/auth/login', {email, password, source: 'w'});
// const response = await axios.get('http://localhost:8000/v1/auth/me');
// const response = await AuthService.login({email, password, source: 'w'});
// if (response) {
// 	return fulfillWithValue(response.data);
// } else {
// 	return rejectWithValue("err.response.data");
// }
// return response.data;
// } catch (err) {
// }
//
// return new Promise((resolve, reject) => {
// 	axios.post('http://localhost:8000/v1/auth/login', {email, password, source: 'w'})
// 		.then(res => {
// 			return resolve(res.data);
// 		})
// 		.catch(err => {
// 			return rejectWithValue(err.response?.data?.message || 'Error');
// 		});
// });
//
// try {
// 	// const response = await AuthService.login({email, password, source: 'w'});
// 	await axios.post('http://localhost:8000/v1/auth/login', {email, password, source: 'w'})
// 		.then(res => {
// 			return Promise.resolve(res.data);
// 		})
// 		.catch(err => {
// 			return Promise.reject(err.response?.data?.message || 'Error');
// 		});
// 	// console.log(response);
// 	// return Promise.resolve({access_token: "asdjhasdgajshdgsajh"});
// } catch (err) {
// 	console.error(err);
// 	return Promise.reject(err);
// }
//
// return {
// 	access_token: "adkjgasldkjahsgldkjashdlaskj"
// }
//
// try {
// 	const response = await AuthService.login({email, password, source: 'w'});
// 	// const token = response.data.user.access_token;
// 	// localStorage.setItem(AUTH_TOKEN, token);
// 	return response.data;
// } catch (err) {
// 	return Promise.reject(err.response?.data?.message || 'Error');
// 	// return rejectWithValue(err.response?.data?.message || 'Error')
// }
//
//
// export const signUp = createAsyncThunk('auth/register',async (data, { rejectWithValue }) => {
// 	const { email, password } = data
// 	try {
// 		const response = await AuthService.register({email, password})
// 		const token = response.data.token;
// 		localStorage.setItem(AUTH_TOKEN, token);
// 		return token;
// 	} catch (err) {
// 		return rejectWithValue(err.response?.data?.message || 'Error')
// 	}
// })
//
// export const signOut = createAsyncThunk('auth/logout', async () => {
//     localStorage.removeItem(AUTH_TOKEN);
//     return true
// });


export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        loginRequest: (state, action) => {
            // state.loading = true
        },
        autoAuthenticated: (state, action) => {
            state.user = action.payload
        },
        authenticated: (state, action) => {
            state.user = action.payload
            state.token = action.payload.access_token
            localStorage.setItem(AUTH_TOKEN, action.payload.access_token)
            state.loading = false
            state.redirect = '/app/dashboard'
        },
        showAuthMessage: (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        },
        hideAuthMessage: (state) => {
            state.message = ''
            state.showMessage = false
        },
        signOutSuccess: (state) => {
            state.loading = false
            state.token = null
            state.redirect = '/auth/login'
        },
        showLoading: (state) => {
            state.loading = true
        },
        signInSuccess: (state, action) => {
            state.user = action.payload
            state.token = action.payload.access_token
            localStorage.setItem(AUTH_TOKEN, action.payload.access_token)
            state.loading = false
            state.redirect = '/app/dashboard'
        },
        signInFailed: (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
            state.token = null
            localStorage.removeItem(AUTH_TOKEN);
            state.redirect = '/auth/login'
        },
        logoutRequest: (state, action) => {
            state.loading = false
            state.token = null
            state.redirect = '/auth/login'
            state.passwordReset = true;
        },
        verifyHash: (state, action) => {},
        verifyHashSuccess: (state, action) => {
            state.invalidResetPassToken = false;
        },
        verifyHashFailed: (state, action) => {
            state.invalidResetPassToken = true;
        },
        setupPassword: (state, action) => {
            state.passwordReset = false;
        },
        setupPasswordSuccess: (state, action) => {
            state.passwordReset = true;
        },
        setupPasswordFailed: (state, action) => {
            state.passwordReset = false;
        },
    },
    // extraReducers: (builder) => {
    //     builder
    //         .addCase(signIn.pending, (state) => {
    //             state.loading = true
    //         })
    //         .addCase(signIn.fulfilled, (state, action) => {
    //             state.loading = false
    //             state.redirect = '/'
    //             state.user = action.payload
    //             state.token = action.payload.access_token
    //             localStorage.setItem(AUTH_TOKEN, action.payload.access_token)
    //         })
    //         .addCase(signIn.rejected, (state, action) => {
    //             state.message = action.payload
    //             state.showMessage = true
    //             state.loading = false
    //         })
    //         .addCase(signOut.fulfilled, (state) => {
    //             state.loading = false
    //             state.token = null
    //             state.redirect = '/'
    //         })
    //         .addCase(signOut.rejected, (state) => {
    //             state.loading = false
    //             state.token = null
    //             state.redirect = '/'
    //         });
    //     .addCase(signUp.pending, (state) => {
    //     	state.loading = true
    //     })
    //     .addCase(signUp.fulfilled, (state, action) => {
    //     	state.loading = false
    //     	state.redirect = '/'
    //     	state.token = action.payload
    //     })
    //     .addCase(signUp.rejected, (state, action) => {
    //     	state.message = action.payload
    //     	state.showMessage = true
    //     	state.loading = false
    //     })
    // },
});

export const {
    loginRequest,
    authenticated,
    autoAuthenticated,
    showAuthMessage,
    hideAuthMessage,
    signOutSuccess,
    signInFailed,
    showLoading,
    signInSuccess,
    logoutRequest,
    verifyHash,
    verifyHashSuccess,
    verifyHashFailed,
    setupPassword,
    setupPasswordSuccess,
    setupPasswordFailed,
} = authSlice.actions;

export default authSlice.reducer;
